import { userApis } from '@/configs/apis';

export function getTokens() {
  const id_token = userApis.getIdToken();

  if (!id_token) {
    throw new Error('No id_token');
  }

  return {
    id_token,
  };
}
